import React from 'react'
import ProfileSliderCard from './ProfileSliderCard'

import useWindowDimensions from '../../helpers/getWindowsDimensions'
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext,
    DotGroup
} from 'pure-react-carousel';
import './ProfileCarousel.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
const ProfileCarousel = ({theItems, modalToggle, selectItem, userId}) => {
    const { height, width } = useWindowDimensions()
    //console.log("THe WIDTH", width)
    return (
        <CarouselProvider
                    visibleSlides={`${width>=1024 ? 5 : `${width}` > 640 ?  4 : 2}`}
                    totalSlides={theItems.length}
                    step={2}
                    naturalSlideWidth={`${width>=1536 ? 100 : 100}`}
                    naturalSlideHeight={`${width>=1536 ? 200 : 100}`}
                    dragEnabled={false} 
                    touchEnabled={false}
                    className="relative"
                >
                    <div className={"relative mx-auto max-w-4xl xl:max-w-7xl"}>
                        <Slider className={"max-w-4xl xl:max-w-full"}>
                            {theItems.map((item,index) => {
                                return (
                                    <Slide key={index} index={index} onClick={() => selectItem(item)}>
                                        <ProfileSliderCard item={item} modalToggle={modalToggle} userId={userId}/>
                                    </Slide>
                                )
                            })}
                        </Slider>
                        {/* <ButtonBack className={"absolute top-2/4 left-0 text-blue-600"}>Back</ButtonBack>
                        <ButtonNext className={"s.buttonNext"}>Next</ButtonNext> */}
                    
                    <DotGroup className={"dot-center"} />
                    <ButtonBack>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 xl:h-14 xl:w-14" fill="#000000" viewBox="0 0 24 24" stroke="#ffffff">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
                        </svg>
                    </ButtonBack>
                    <ButtonNext>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 xl:h-14 xl:w-14" fill="#000000"viewBox="0 0 24 24" stroke="#ffffff">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                    </ButtonNext>
                    </div>
                </CarouselProvider>
    )
}

export default ProfileCarousel